<template>
  <svg
    class="custom-icon"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6073_18932)">
      <rect width="40" height="40" rx="20" fill="#F9401D" />
      <path
        d="M20.0001 6.40039H20C12.4889 6.40039 6.40002 12.4893 6.40002 20.0003V20.0005C6.40002 27.5115 12.4889 33.6004 20 33.6004H20.0001C27.5111 33.6004 33.6 27.5115 33.6 20.0005V20.0003C33.6 12.4893 27.5111 6.40039 20.0001 6.40039Z"
        fill="#F9401D"
      />
      <path
        d="M21.8668 27.1992H24.8001V11.1992H20.5334C16.2425 11.1992 13.988 13.2942 13.988 16.3791C13.988 18.8424 15.2244 20.2928 17.4304 21.7892L13.6001 27.1992H16.7758L21.0425 21.1446L19.5637 20.2007C17.7698 19.0496 16.8971 18.1518 16.8971 16.218C16.8971 14.5144 18.1576 13.3633 20.5576 13.3633H21.8668V27.1992Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6073_18932">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
